"use strict";

import { Color } from "./statics.js";
export const GoogleSigninButton = () => null;
GoogleSigninButton.Color = Color;
GoogleSigninButton.Size = {
  Icon: 0,
  Standard: 1,
  Wide: 2
};
//# sourceMappingURL=GoogleSigninButton.web.js.map